import { render, staticRenderFns } from "./ProductHead.vue?vue&type=template&id=5fb2ceea&scoped=true&"
import script from "./ProductHead.vue?vue&type=script&lang=js&"
export * from "./ProductHead.vue?vue&type=script&lang=js&"
import style0 from "./ProductHead.vue?vue&type=style&index=0&id=5fb2ceea&lang=scss&scoped=true&"
import style1 from "./ProductHead.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb2ceea",
  null
  
)

export default component.exports